
// Note: DO NOT edit this file or any module files during projects. 
// Use the child-theme `index.js` to extend or create logic in projects.

// CSS/Sass
import '../scss/main.scss';

// Global
import jQuery from 'jquery';

// Vendors (List alphabetically)
import './vendors/FontAwesome';

// Modules (List alphabetically)
import { getTailwindConfig } from './utility/tailwind';
import Accordion from './modules/Accordion';
import OffCanvasMenu from './modules/OffCanvasMenu';
import Select from './modules/Select';


//
// Set jQuery
//
// TODO: Not sure if this is required going forward. 
// Retest with jQuery-reliant blocks and remove if not required.
//

window.$ = jQuery;
window.jQuery = jQuery;


// Trigger the block loader plugin in Webpack.
// TODO: Move this into separate file.

if (typeof includeChildAssets === 'function') {
    includeChildAssets()
}
if (typeof includeBlocks === 'function') {
    includeBlocks()
}
